export const contactInfo = {
	heading: {
		sv: "Kontaktuppgifter",
	},
	subHeading: {
		sv: "Här är uppgifter som vi hämtat från Bolagsverket.",
	},
	subHeading2: {
		sv: "För att vi ska kunna hjälpa dig med dina ärenden behöver vi ha företagets kontaktuppgifter och uppgifter till företagets kontaktperson.",
	},
	companyInfo: {
		heading: {
			sv: "Företagets address",
		},
		visitingAddress: {
			sv: "Besöksadress",
		},
		postAddress: {
			sv: "Utdelningsadress",
		},
	},
	companyContact: {
		heading: {
			sv: "Företagets kontaktuppgifter",
		},
		countryCode: {
			sv: "Välj landskod",
		},
		phoneNumber: {
			sv: "Telefon",
		},
	},
	applicantContact: {
		heading: {
			sv: "Dina kontaktuppgifter",
		},
		countryCode: {
			sv: "Välj landskod",
		},
		phoneNumber: {
			sv: "Telefon",
		},
	},
	tooltip: {
		sv: "Genom att fylla i uppgifterna godkänner du att vi kontaktar dig och att vi skickar marknadsföring om Svea Bank. \n\nVi hanterar alltid dina kontaktuppgifter i enlighet med lagar och riktlinjer och att du kan när som helst avsluta din prenumeration av marknadsföring.\n\nLäs mer om vår [integritetspolicy](https://www.svea.com/se/sv/om-oss/personuppgiftsbehandling/).",
	},
};
